function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { GUTTER_SELECTOR, GUTTER_SIZE_IN_PX, isEmptyDocument } from '@atlaskit/editor-common/utils';
import { scrollGutterPluginKey } from './plugin-key';
import { getKeyboardHeight } from './util/get-keyboard-height';
var MIN_TAP_SIZE_IN_PX = 40;
function supportsIntersectionObserver() {
  if (typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.IntersectionObserverEntry.prototype) {
    return true;
  }
  return false;
}
function listenForGutterVisibilityChanges(scrollElement, gutterIsVisible) {
  if (supportsIntersectionObserver()) {
    var observer = new IntersectionObserver(function (entries, _) {
      entries.forEach(function (entry) {
        gutterIsVisible(entry.intersectionRatio > 0);
      });
    }, {
      root: scrollElement,
      rootMargin: '0px',
      threshold: 0
    });
    return observer;
  }
  return undefined;
}

/**
 * Create a gutter element that can be added or removed from the DOM.
 */
function createGutter(gutterSize) {
  var gutter = document.createElement('div');
  gutter.style.paddingBottom = "".concat(gutterSize, "px");
  gutter.id = GUTTER_SELECTOR.substr(1);
  var initialized = false;
  var mounted = false;
  var currentParent = null;
  var observer;
  var isVisible = false;
  return {
    addGutter: function addGutter(parent) {
      if (parent) {
        var _parent$deref;
        currentParent = parent;
        (_parent$deref = parent.deref()) === null || _parent$deref === void 0 || _parent$deref.appendChild(gutter);
        mounted = true;
        if (observer) {
          observer.observe(gutter);
        }
      }
    },
    removeGutter: function removeGutter() {
      var _currentParent;
      var parentRef = (_currentParent = currentParent) === null || _currentParent === void 0 ? void 0 : _currentParent.deref();
      if (parentRef && mounted) {
        mounted = false;
        parentRef.removeChild(gutter);
        if (observer) {
          observer.unobserve(gutter);
        }
      }
    },
    element: function element() {
      return gutter;
    },
    isMounted: function isMounted() {
      return mounted;
    },
    visible: function visible() {
      // If we know whether it's visible we can avoid expensive calculations
      if (observer) {
        return isVisible;
      }
      // Fallback for legacy browsers assumes it's visible (if mounted)
      return mounted;
    },
    observe: function observe(scrollElement) {
      if (!initialized) {
        initialized = true;
        observer = listenForGutterVisibilityChanges(scrollElement, function (visible) {
          return isVisible = visible;
        });
      }
    },
    destroy: function destroy() {
      if (observer) {
        observer.disconnect();
      }
      observer = undefined;
      this.removeGutter();
      initialized = mounted = false;
    }
  };
}

/**
 * Get caret top position given the current selection,
 * use start container position as fallback
 */
function getCaretTopPosition() {
  var windowSelection = window.getSelection();
  if (windowSelection && windowSelection.rangeCount > 0) {
    var range = windowSelection.getRangeAt(0);
    if (range) {
      var clientRects = range.getClientRects();
      // Return client rects
      if (clientRects && clientRects.length > 0) {
        return clientRects[0].top;
      }

      // Return container top
      // Ignored via go/ees005
      // eslint-disable-next-line @atlaskit/editor/no-as-casting
      var container = range.startContainer;
      if (container && container.getBoundingClientRect) {
        return container.getBoundingClientRect().top;
      }
    }
  }
  return;
}
function scrollToGutterElement(scrollContainer, gutterElement, gutterSize) {
  var viewportHeight = scrollContainer.offsetHeight;
  var viewportOffsetY = scrollContainer.getBoundingClientRect().top;
  var caretTopPosition = getCaretTopPosition();
  if (!caretTopPosition) {
    return false;
  }
  var caretTopFromContainer = caretTopPosition - viewportOffsetY;
  var gutterThresholdTop = viewportHeight - gutterSize - MIN_TAP_SIZE_IN_PX * 2;
  if (caretTopFromContainer < gutterThresholdTop) {
    return false;
  }

  // Clamp the scroll position to above the scroll gutter element.
  gutterElement.scrollIntoView(false);

  // Mark scrolling as handled so that other plugin's don't override our position.
  return true;
}
export default (function () {
  var pluginOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getScrollElement = pluginOptions.getScrollElement,
    allowCustomScrollHandler = pluginOptions.allowCustomScrollHandler,
    _pluginOptions$gutter = pluginOptions.gutterSize,
    gutterSize = _pluginOptions$gutter === void 0 ? GUTTER_SIZE_IN_PX : _pluginOptions$gutter;
  if (!getScrollElement) {
    return undefined;
  }
  var gutter = createGutter(gutterSize);
  var scrollElement = null; // | undefined;

  return new SafePlugin({
    key: scrollGutterPluginKey,
    state: {
      init: function init() {
        return {};
      },
      apply: function apply(tr, pluginState) {
        if (tr.getMeta(scrollGutterPluginKey)) {
          return tr.getMeta(scrollGutterPluginKey);
        }
        return pluginState;
      }
    },
    props: {
      // Determines the distance (in pixels) between the cursor and the end of the visible viewport at which point,
      // when scrolling the cursor into view, scrolling takes place.
      // Defaults to 0: https://prosemirror.net/docs/ref/#view.EditorProps.scrollThreshold
      scrollThreshold: gutterSize / 2,
      // Determines the extra space (in pixels) that is left above or below the cursor when it is scrolled into view.
      // Defaults to 5: https://prosemirror.net/docs/ref/#view.EditorProps.scrollMargin
      scrollMargin: gutterSize,
      // Called when the view, after updating its state, tries to scroll the selection into view
      // https://prosemirror.net/docs/ref/#view.EditorProps.handleScrollToSelection
      handleScrollToSelection: function handleScrollToSelection() {
        if (allowCustomScrollHandler === false) {
          return false;
        }
        if (!gutter.isMounted() || !gutter.visible() || !scrollElement) {
          // Avoid scrolling until applicable
          return false;
        }
        return scrollToGutterElement(scrollElement, gutter.element(), gutterSize);
      }
    },
    view: function view(_view) {
      // Store references to avoid lookups on successive checks.
      scrollElement = getScrollElement(_view);
      // Ignored via go/ees005
      // eslint-disable-next-line @atlaskit/editor/no-as-casting
      var editorElement = _view.dom;
      var editorParentElement = editorElement.parentElement;
      var viewportElementHeight = 0;
      var contentElementHeight = 0;
      var addAndObserveGutter = function addAndObserveGutter() {
        if (!gutter.isMounted()) {
          // Ignored via go/ees005
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          gutter.observe(scrollElement);
          gutter.addGutter(editorParentElement ? new WeakRef(editorParentElement) : null);
        }
      };
      var toggleGutter = function toggleGutter(contentSize, threshold) {
        if (pluginOptions.persistScrollGutter) {
          if (!isEmptyDocument(_view.state.doc)) {
            addAndObserveGutter();
          } else {
            gutter.removeGutter();
          }
          return;
        }

        // Add or remove the gutter based on whether the content is about to exceed the viewport height.
        // We do this to ensure there is sufficient white space below the last content node in order to
        // see any UI control elements which may sit beneath it.
        if (contentSize >= threshold) {
          addAndObserveGutter();
        } else {
          if (gutter.isMounted()) {
            gutter.removeGutter();
          }
        }
      };
      var observerCallback = function observerCallback(entries) {
        var _iterator = _createForOfIteratorHelper(entries),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            var elementHeight = Math.round(entry.contentRect.height);
            if (entry.target === scrollElement) {
              var _getKeyboardHeight;
              var keyboardHeight = (_getKeyboardHeight = getKeyboardHeight(_view === null || _view === void 0 ? void 0 : _view.state)) !== null && _getKeyboardHeight !== void 0 ? _getKeyboardHeight : 0;
              viewportElementHeight = elementHeight - keyboardHeight;
            } else if (entry.target === editorParentElement) {
              contentElementHeight = elementHeight - (gutter.isMounted() ? gutterSize : 0);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        toggleGutter(contentElementHeight, viewportElementHeight);
      };

      // Subscribe to updates of the height of the viewport and content elements
      // We toggle the value when it is set here or when PM updates to ensure we're using
      // the latest.
      var resizeObserver = new ResizeObserver(observerCallback);
      if (scrollElement && editorParentElement) {
        resizeObserver.observe(scrollElement);
        resizeObserver.observe(editorParentElement);
      }
      return {
        destroy: function destroy() {
          // Remove if it's mounted
          gutter.destroy();
          scrollElement = editorParentElement = editorElement = null;
          resizeObserver.disconnect();
        },
        /**
         * Toggle the Scroll Gutter Element
         */
        update: function update(view, prevState) {
          if (!scrollElement || !editorParentElement) {
            return;
          }
          var state = view.state;
          if (prevState.selection === state.selection) {
            // No need to recheck if the selected node hasn't changed.
            return;
          }
          var gutterThresholdHeight = viewportElementHeight - gutterSize;
          toggleGutter(contentElementHeight, gutterThresholdHeight);
        }
      };
    }
  });
});